import { useState, FormEvent } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@expertloop/i18n/react";
import { adminApi, AdminApiError } from "../services/api";

/**
 * Demande d'un lien de réinitialisation du mot de passe d'administration.
 * La réponse est la même que l'adresse existe ou non : l'écran de confirmation
 * ne révèle rien sur les comptes.
 */
export function ForgotPasswordPage() {
	const { t } = useI18n();
	const [email, setEmail] = useState("");
	const [error, setError] = useState("");
	const [isSending, setIsSending] = useState(false);
	const [hasSent, setHasSent] = useState(false);

	const handleSubmit = async (event: FormEvent) => {
		event.preventDefault();
		setError("");
		setIsSending(true);

		try {
			await adminApi.post("/admin/auth/forgot-password", { email });
			setHasSent(true);
		} catch (err) {
			const isRateLimited = err instanceof AdminApiError && err.status === 429;
			setError(isRateLimited ? t("adminPasswordReset.tooManyRequests") : t("adminPasswordReset.requestFailed"));
		} finally {
			setIsSending(false);
		}
	};

	if (hasSent) {
		return (
			<div className="login-page">
				<div className="login-card">
					<h1>{t("adminPasswordReset.sentTitle")}</h1>
					<p className="subtitle">{t("adminPasswordReset.sentBody")}</p>
					<div className="login-footer">
						<Link to="/login" className="link-button">
							{t("adminPasswordReset.backToLogin")}
						</Link>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="login-page">
			<div className="login-card">
				<h1>{t("adminPasswordReset.forgotTitle")}</h1>
				<p className="subtitle">{t("adminPasswordReset.forgotIntro")}</p>

				{error && <div className="error-message">{error}</div>}

				<form onSubmit={handleSubmit}>
					<div className="form-group">
						<label htmlFor="email">{t("auth.login.email")}</label>
						<input
							id="email"
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							placeholder={t("admin.login.emailPlaceholder")}
							required
							autoFocus
						/>
					</div>

					<button type="submit" className="btn btn-primary" disabled={isSending}>
						{isSending ? t("adminPasswordReset.sending") : t("adminPasswordReset.send")}
					</button>
				</form>

				<div className="login-footer">
					<Link to="/login" className="link-button">
						{t("adminPasswordReset.backToLogin")}
					</Link>
				</div>
			</div>
		</div>
	);
}
